export enum TimeFormFieldEnum {
    TIME_ZONE = 'timezone',
    TIME = 'time',
}

export interface TimeFormInterface {
    [TimeFormFieldEnum.TIME_ZONE]: string;
    [TimeFormFieldEnum.TIME]?: string;
}
